import { render } from "./FormTel.vue?vue&type=template&id=1c7e8950&ts=true"
import script from "./FormTel.vue?vue&type=script&lang=ts"
export * from "./FormTel.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__